import React from 'react';
import './PageBackNavigation.css';

export default function PageBackNavigation({ onBack, label = 'Back', position = 'top' }: any) {
  const text = String(label).replace(/^\s*[←⇦]\s*/, '') || 'Back';
  return (
    <nav className={`ae-page-back ae-page-back-${position}`} aria-label={`${position === 'bottom' ? 'Bottom' : 'Top'} return navigation`}>
      <button type="button" onClick={onBack}>
        <span aria-hidden="true">←</span>
        <span>{text}</span>
      </button>
    </nav>
  );
}